<template>
  <div>
    <modal
      :show.sync="addLiveEvent"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Add Live URL
      </h6>
      <div>
        <p>Name</p>
        <base-input
          v-model="name"
          placeholder="Enter Heading"
          class="cust-mb0 mb-2"
          :rules="{ required: true }"
          name="name"
        ></base-input>
        <p class="mt-2">Url</p>
        <base-input
          v-model="url"
          placeholder="Enter URL"
          class="cust-mb0"
          :rules="{ required: true }"
          name="URL"
        ></base-input>
        <div class="d-flex w-full gap-4 datepickerclass">
          <div class="w-1/2 my-4">
            <b-form-group label="Date:">
              <date-picker
                slot-scope="{ focus, blur }"
                @on-open="focus"
                @on-close="blur"
                required
                :config="{ allowInput: true }"
                placeholder="Select Date"
                v-model="selectdate"
                class="w-full"
                valueType="format"
              >
              </date-picker>
            </b-form-group>
          </div>
          <div class="w-1/2 my-4">
            <b-form-group label="Time:">
              <date-picker
                v-model="selecttime"
                format="HH:mm"
                value-type="format"
                type="time"
                class="w-full"
                :config="configdateTimePicker"
                placeholder="HH:mm"
              >
              </date-picker>
            </b-form-group>

            <!-- <b-button type="primary"
          >Create Chapter</b-button -->
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click.once="handleAdd()"
          >ADD LIVE</base-button
        >
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      name: "",
      url: "",
      selectdate: "",
      selecttime: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },
    };
  },
  props: {
    addLiveEvent: Boolean,
    chapter: Object,
  },

  methods: {
    closeModal() {
      this.$emit("close-addLiveEvent");
    },
    reset() {
      this.url = "";
      this.name = "";
      this.selectdate = "";
      this.selecttime = "";
    },
    async handleAdd() {
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("eLearning/addLive", {
          url: this.url,
          name: this.name,
          date: this.selectdate,
          time: this.selecttime,
          course: this.chapter.course[0],
          chapter: this.chapter._id,
        });
        if (data.code == 200) {
          loader.close();
          await this.$store.dispatch("eLearning/getChapterByCourseId", {
            id: this.chapter.course[0],
          });
          await this.$store.dispatch("eLearning/GetLive");
          this.$swal.fire({
            title: "Added",

            text: "Added Successfully!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.reset();
          this.closeModal();
        }
      } catch (err) {
        loader.close();
      }
    },
  },
  mounted() {
    this.reset();
  },
};
</script>
<style>
.datepickerclass .mx-datepicker {
  width: 100%;
}
</style>
